module.exports = __webpack_public_path__ + "static/media/playIconWhiteSmall.e2abe499.svg";